<template>
  <transition name="el-zoom-in-top">
    <div class="layout-network-notifier select-none" :class="{'connected': isConnected, 'connecting': !isConnected && connecting}" v-if="showState && (!isConnected || reconnectRetry)">
      <div class="notify-msg" v-if="isConnected">
        <span>网络连接已恢复</span>
      </div>
      <div class="notify-msg" v-else>
        <span v-if="connecting">
          网络重连中，请稍候...
        </span>
        <span v-else>
          失去网络连接，<span v-if="retryDelay > 0">{{retryDelay}} 秒后</span><span v-else>等待</span>重新连接...
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import globalEvent from '../../../constants/globalEvent'
import pathUtils from '../../../util/pathUtils'
export default {
  name: 'NetworkNotifier',
  props: {
    showState: {
      type: Boolean,
      default: true
    },
    isConnected: {
      required: true,
      type: Boolean
    },
    tryCount: {
      type: Number,
      default: 0
    },
    connecting: {
      required: true,
      type: Boolean
    },
    retryDelay: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      reconnectRetry: false
    }
  },
  methods: {
    connected () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.reconnectRetry = false
        }, 1000)
      })
    },
    disconnected () {
      this.reconnectRetry = true
    }
  },
  watch: {
    tryCount: function (val) {
      // 尝试超过20次，返回到首页
      if (val > 20) {
        window.location.href = pathUtils.getHomePath()
      }
    }
  },
  mounted () {
    this.$bus.$on(globalEvent.stompClient.CONNECTED, this.connected)
    this.$bus.$on(globalEvent.stompClient.DISCONNECTED, this.disconnected)
  },
  beforeDestroy () {
    this.$bus.$off(globalEvent.stompClient.CONNECTED, this.connected)
    this.$bus.$off(globalEvent.stompClient.DISCONNECTED, this.disconnected)
  }
}
</script>

<style lang="scss">
  .layout-network-notifier {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 18px;
    background: linear-gradient(to bottom, rgba(245,108,108,.75), rgba(255,255,255,0));
    &.connected {
      background: linear-gradient(to bottom, rgba(103,194,58,.75), rgba(255,255,255,0));
    }
    &.connecting {
      background: linear-gradient(to bottom, rgba(230,162,60,.75), rgba(255,255,255,0));
    }
    & > .notify-msg {
      text-align: center;
      font-size: 12px;
      line-height: 18px;
    }
  }
</style>
